import { INVENTORY_ITEM_CATEGORY_ID_TYPES } from 'src/types/itemInventory';

export const isCorePlan = (planId: string): boolean =>
  planId === INVENTORY_ITEM_CATEGORY_ID_TYPES.AZAR_CORE;
